var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-block rounded text-xs leading-none bg-opacity-10",class:[("text-" + _vm.color + "-500"),("bg-" + _vm.color + "-500"), _vm.padding]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }